import { PanelTypes } from "@flightpath/coreui/dist/ui/Panel";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Panel } from "../../../../../../../../components/ui/Panel";
import { PositionedSpinner } from "../../../../../../../../components/ui/PositionedSpinner";
import { Tag } from "../../../../../../../../components/ui/Tag";
import PermissionsContext from "../../../../../../../../contexts/permissions/PermissionsContext";
import { PermissionFields } from "../../../../../../../../contexts/permissions/PermissionsTypes";
import I18n from "../../../../../../../localization/I18n";
import { useCurrentOrganisationId } from "../../../../../../../../services/local/organisationContext/OrganisationContextModel";
import { ManageAudienceStakeholderTagForm } from "./ManageAudienceStakeholderTagForm";
import { AudienceStakeholderTagsSidebarModel } from "./AudienceStakeholderTagsSidebar_model";

export interface AudienceStakeholderTagsSidebarProps {
  projectId: number;
  itemId: number;
}

export const AudienceStakeholderTagsSidebar: React.FC<AudienceStakeholderTagsSidebarProps> = observer(props => {
  const { projectId, itemId } = props;
  const organisationId = useCurrentOrganisationId();
  const [model, setModel] = useState(() => new AudienceStakeholderTagsSidebarModel(organisationId, projectId, itemId));

  useEffect(() => {
    if (model.projectId !== projectId) {
      setModel(new AudienceStakeholderTagsSidebarModel(organisationId, projectId, itemId));
    }
  }, [organisationId, projectId, itemId, model.projectId]);

  useEffect(() => {
    model.onMount();
  }, [model]);

  if (!model || model.isLoading) return <PositionedSpinner />;

  const canEdit = PermissionsContext.canEditField(PermissionFields.STAKEHOLDERS, organisationId, projectId);
  const { audienceStakeholder } = model;

  return (
    <div className="container-fluid">
      {canEdit ? (
        <div className="row mb-4">
          <div className="col">
            <ManageAudienceStakeholderTagForm
              projectId={projectId}
              organisationId={organisationId}
              audienceStakeholder={model.audienceStakeholder}
              refreshHandler={model.onMount}
            />
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col">
            {audienceStakeholder.audienceStakeholderTags.length > 0 ? (
              audienceStakeholder.audienceStakeholderTags.map(t => (
                <Tag
                  tagText={t.tag.name}
                  isEditable={false}
                  testId={t.id + ""}
                  key={t.id}
                  isNew={false}
                  onClick={e => {
                    model.removeTag(t.id);
                  }}
                />
              ))
            ) : (
              <div>
                <Panel.Panel hasBorderRadius={true} type={PanelTypes.OUTLINES} className="py-2 text-center">
                  <div>{I18n.t("phrases.noTags")}</div>
                </Panel.Panel>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
});
